import * as angular from 'angular';

function filterFunction($filter: ng.IFilterService) {
    return function (input: Date) {
        if (input.getHours() === 0 && input.getMinutes() === 0) {
            return '(All day)';
        } else {
            return $filter('date')(input, 'hh-mm a');
        }
    };
}
angular.module('naut')
    .filter('campaignTime', ['$filter', filterFunction]);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/common/filters/campaignTime.filter.ts